import { formatValue, NumeralTypes, NumeralType } from '@common/utils/formatNumberValue';
import { numeralValueFormatter } from './numeralValueFormatter';

const FormatTypes = {
  DEFAULT: '0,0.[00000]',
  DECIMAL: '0,0.00',
  PERCENTAGE: '0.000000',
  PERCENT_4: '0.0000',
  PERCENT_2: '0.00',
};

const getFormat = (type: NumeralType) => {
  switch (type) {
    case NumeralTypes.DECIMAL:
      return FormatTypes.DECIMAL;
    case NumeralTypes.PERCENTAGE:
      return FormatTypes.PERCENTAGE;
    case NumeralTypes.PERCENT_2:
      return FormatTypes.PERCENT_2;
    case NumeralTypes.PERCENT_4:
      return FormatTypes.PERCENT_4;
    default:
      return FormatTypes.DEFAULT;
  }
};

const getFixedPrecision = (type: NumeralType) => {
  if (type === NumeralTypes.PERCENTAGE) {
    return '8';
  }

  if (type === NumeralTypes.PERCENT_4) {
    return '6';
  }

  return '2';
};

type CustomNumeralValueFormatterParams = {
  shouldDisplayZero: boolean,
  hideDecimals: boolean,
  negativeMinus: boolean,
  type: NumeralType,
  suppressHidingDecimalPlaces: boolean,
}
export const customNumeralValueFormatter = ({
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
  type,
  suppressHidingDecimalPlaces,
}: CustomNumeralValueFormatterParams) => ({
  value: rawValue,
}: { value: string | number | null | undefined }) => {
  const value = rawValue || '0';

  if (!shouldDisplayZero && (value === '0' || value === '-')) {
    return '-';
  }

  const decimalFormat = hideDecimals && !suppressHidingDecimalPlaces ? '0,0' : getFormat(type);

  const decimalOrPercentageTypes: NumeralType[] = [
    NumeralTypes.PERCENTAGE,
    NumeralTypes.PERCENT_2,
    NumeralTypes.PERCENT_4,
  ];
  const decimalOrPercentageFormat
    = decimalOrPercentageTypes.includes(type)
      ? `${decimalFormat}%`
      : decimalFormat;
  const customFormat = negativeMinus ? `-${decimalOrPercentageFormat}` : `(${decimalOrPercentageFormat})`;

  const fixedPrecision = parseInt(
    hideDecimals && !suppressHidingDecimalPlaces ? '2' : getFixedPrecision(type),
    10
  );

  const parsedValue = formatValue({
    value,
    type,
    customFormat: customFormat.replace(/,/g, ''),
    fixedPrecision,
    acceptRaw: false,
  });

  if (!shouldDisplayZero && !isNaN(Number(parsedValue)) && !Number(parsedValue)) {
    return '-';
  }

  return numeralValueFormatter({
    customFormat,
    fixedPrecision,
    type,
  })({
    value,
  });
};

